import find from 'lodash/find';
import includes from 'lodash/includes';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DOMUtils from '@spothero/utils/dom';
import TextButton from '@spothero/ui/text-button';

/* this string is very tightly coupled to the `facilities.py` serializer. they should be changed in tandem and/or
refactored to not be garbage. */
const IN_OUT_RESTRICTION =
    'This facility does NOT allow in/out privileges. You CANNOT enter & exit more than once.';

export default class ThingsYouShouldKnow extends Component {
    static propTypes = {
        className: PropTypes.string,
        rate: PropTypes.object,
        facility: PropTypes.object.isRequired,
        isMonthly: PropTypes.bool.isRequired,
        onShowRateDetailsClick: PropTypes.func.isRequired,
    };

    _onRateDetailsClick = evt => {
        evt.preventDefault();

        this.props.onShowRateDetailsClick(
            DOMUtils.attr(evt.currentTarget, 'data-section')
        );
    };

    _renderTitle() {
        return <h4 className="subtitle">Things You Should Know</h4>;
    }

    _renderMonthly() {
        const {rate, facility} = this.props;
        const {
            height_restriction_description: heightRestrictionDescription,
        } = facility;
        const {
            contract,
            in_out: inOut,
            parking_pass_type: parkingPassType,
            new_description: newDescription,
            description,
            newMonthlyRate,
        } = rate;

        if (!rate) {
            return null;
        }

        if (newMonthlyRate) {
            return (
                <>
                    {this._renderTitle()}
                    <ul className="ThingsYouShouldKnow-list">
                        {heightRestrictionDescription && (
                            <li className="ThingsYouShouldKnow-list-item">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: heightRestrictionDescription,
                                    }}
                                />
                            </li>
                        )}
                        {contract.required && (
                            <li className="ThingsYouShouldKnow-list-item">
                                Contract Required.
                                <TextButton
                                    data-section="contract"
                                    onClick={this._onRateDetailsClick}
                                >
                                    Important Details
                                </TextButton>
                                .
                            </li>
                        )}
                        {inOut.allowed === 'no' && (
                            <li className="ThingsYouShouldKnow-list-item">
                                In/Out NOT allowed. Once you leave, that&apos;s
                                it, my friend.
                            </li>
                        )}
                        {inOut.allowed === 'yes_fee' && (
                            <li className="ThingsYouShouldKnow-list-item">
                                There is a ${inOut.fee} charge for each in/out.
                            </li>
                        )}
                        {inOut.allowed === 'yes_limited' && (
                            <li className="ThingsYouShouldKnow-list-item">
                                In/outs are limited to {inOut.limit} per{' '}
                                {inOut.limit_type}.
                            </li>
                        )}
                        {inOut.allowed === 'yes_limited_fee' && (
                            <li className="ThingsYouShouldKnow-list-item">
                                In/outs are limited to {inOut.limit} per{' '}
                                {inOut.limit_type}. Additional in/outs are
                                allowed for a {inOut.fee} fee.
                            </li>
                        )}
                        {parkingPassType === 'self_park_see_attendant' && (
                            <li className="ThingsYouShouldKnow-list-item">
                                You will display your parking pass park at this
                                facility.
                            </li>
                        )}
                        {parkingPassType === 'scan_in_out' && (
                            <li className="ThingsYouShouldKnow-list-item">
                                You will scan your parking pass park at this
                                facility.
                            </li>
                        )}
                        {parkingPassType === 'hang' && (
                            <li className="ThingsYouShouldKnow-list-item">
                                You will receive a hang tag to park at this
                                facility.
                            </li>
                        )}
                        {parkingPassType === 'license_plate' && (
                            <li className="ThingsYouShouldKnow-list-item">
                                Your license plate number will allow you to park
                                at this facility.
                            </li>
                        )}
                        {parkingPassType === 'access_card' && (
                            <li className="ThingsYouShouldKnow-list-item">
                                You will receive an access pass to park at this
                                facility.
                            </li>
                        )}
                        {parkingPassType === 'sticker' && (
                            <li className="ThingsYouShouldKnow-list-item">
                                You will receive a sticker to park at this
                                facility.
                            </li>
                        )}
                    </ul>
                    {newDescription && (
                        <div
                            className="OtherDescription"
                            dangerouslySetInnerHTML={{__html: newDescription}}
                        />
                    )}
                </>
            );
        } else {
            if (description) {
                return (
                    <>
                        {this._renderTitle()}
                        <div
                            className="OtherDescription"
                            dangerouslySetInnerHTML={{__html: newDescription}}
                        />
                    </>
                );
            }
        }
    }

    _renderTransient() {
        const {
            facility: {restrictions},
            rate,
        } = this.props;

        let inOut = false;

        if (rate && rate.amenities) {
            if (find(rate.amenities, {slug: 'in-out'})) {
                inOut = true;
            }
        }

        if (!restrictions || !restrictions.length) {
            return null;
        }

        return (
            <>
                {this._renderTitle()}
                <ul className="ThingsYouShouldKnow-list">
                    {restrictions.map((restriction, i) => {
                        if (inOut && restriction === IN_OUT_RESTRICTION) {
                            return null;
                        }

                        return (
                            <li
                                key={i}
                                className="ThingsYouShouldKnow-list-item"
                            >
                                <span
                                    className={
                                        includes(restriction, 'VIP')
                                            ? 'text-red'
                                            : ''
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: restriction,
                                    }}
                                />
                            </li>
                        );
                    })}
                </ul>
            </>
        );
    }

    render() {
        const {className, rate, isMonthly} = this.props;
        const classes = classNames(
            'SpotDetails-section',
            'ThingsYouShouldKnow',
            className
        );

        return (
            <div className={classes}>
                {rate && isMonthly
                    ? this._renderMonthly()
                    : this._renderTransient()}
            </div>
        );
    }
}
